import * as types from "./mutation-types";

/**
 * Export all mutations
 */
export default {
  /**
   * @param state
   * @param checklists
   */
  [types.SET_CHECKLISTS](state, checklists) {
    state.checklists = checklists;
  },
  /**
   * @param state
   * @param show_latter
   */
  [types.SET_SHOW_LATTER_CHECKLIST](state, show_latter) {
    state.show_latter = show_latter;
  },

  [types.ADD_ROUTE_TO_BREADCRUMBS](state, to) {

    const { breadcrumbs } = state;

    if ( breadcrumbs.history.find(breadcrumb => breadcrumb.name === to.name) ) return;

    breadcrumbs.history.push(to)
  },

  [types.RESET_ALL_BREADCRUMBS](state) {
    state.breadcrumbs.history = state.breadcrumbs.history.filter(breadcrumb => breadcrumb.name === 'home')
  },

  [types.REMOVE_ROUTE_FROM_BREADCRUMBS](state, routesDetails) {
    const { from, to } = routesDetails;

    const { breadcrumbs } = state;

    const { history } = breadcrumbs;

    /* Verifica se tem uma penultima rota na lista de breadcrumbs.   */
    const hasPenultimateRoute = history[history.length - 2];

    /* Se não tiver, não remove a rota. */
    if ( !hasPenultimateRoute ) return;


     /**
     * Só remove a rota atual se o usuário estiver realmente retornando para a penúltima rota registrada.
     * Exemplo:
     * - Penúltima rota no histórico: 'my-wallet'
     * - Rota de destino (to.name): 'products-sharing'
     * -> Como são diferentes, não remove.
     */
    if ( hasPenultimateRoute.name !== to.name ) return;

    /* Remove a rota atual da lista de breadcrumbs. */
    breadcrumbs.history = history.filter(breadcrumb => {

      /* Condição especifica para a rota de edição de dados do parceiro e seus filhos */
      if ( from.name.includes('account') ) {
        return breadcrumb.name !== "account.edit"
      }

      return breadcrumb.name !== from.name
    });
  },

  [types.FORCE_REMOUNT_COMPONENT](state, componentName) {
    const index = state.components_keep_alive.findIndex(c => c.name === componentName);
  
    if (index !== -1) {
      // 1. Remove do keep-alive temporariamente
      const component = state.components_keep_alive.splice(index, 1)[0];
  
      // 2. Aguarda próximo tick e reinjeta com nova key
      setTimeout(() => {
        state.components_keep_alive.push({
          ...component,
          key: component.key + 1, // Atualiza a key para forçar a remontagem do componente
        });
      }, 5);
    }
  }
};
